import { Link } from 'react-router-dom'
export function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 gap-4">
      <div className="text-7xl font-black text-gray-900 font-display">404</div>
      <p className="text-gray-500">Page not found</p>
      <Link to="/dashboard" className="px-5 py-2.5 bg-brand-500 text-white rounded-xl text-sm font-medium hover:bg-brand-600">Go to Dashboard</Link>
    </div>
  )
}
